var app = angular.module("leonardo");

var ReportsContactListFilters = function(
  $scope,
  $controller,
  $timeout,
  $rootScope,
  ReportService,
  ContactTypeRestService,
  PermissionService
) {

  $controller('ReportsFilters', { $scope: $scope });

  $scope.filters_valid = ReportService.filtersContact;

  $scope.filters_options = [];

  $scope.initOptions = function () {
    $scope.filters_options = [
      {
        group: 'hierarchy',
        name: 'By Hierarchy',
        elements: [
          {
            id: 'account_reports',
            name: 'Account',
            label: 'Account',
            inline: false,
            type: 'options',
            multiple: true,
            required: ($scope.authDataService.isAdmin() || $scope.authDataService.isWhiteLabelAdmin()),
            placeholder: 'All Accounts',
            condition: $scope.filterService.accounts.length > 1,
            options: $scope.filterService.accounts,
            conflicts: ['property_reports', 'portfolio_reports', 'group_reports', 'managed_by_reports']
          }
        ]
      },
      {
        id: 'contact_type',
        name: 'Contact Type',
        label: 'Contact Type',
        inline: false,
        type: 'options',
        multiple: true,
        placeholder: 'All Types',
        condition: PermissionService.isOwner(),
        service: ContactTypeRestService,
        conflicts: []
      },
      {
        id: 'name',
        name: 'Contact Name',
        label: 'Contact Name',
        inline: false,
        type: 'text',
        placeholder: 'Name contains',
        condition: true,
        conflicts: [],
        onSubmit: $scope.filter
      },
      {
        id: 'email',
        name: 'Contact Email',
        label: 'Contact Email',
        inline: false,
        type: 'text',
        placeholder: 'Email contains',
        condition: true,
        conflicts: [],
        onSubmit: $scope.filter
      },
      {
        id: 'title',
        name: 'Contact Title',
        label: 'Contact Title',
        inline: false,
        type: 'text',
        placeholder: 'Title contains',
        condition: true,
        conflicts: [],
        onSubmit: $scope.filter
      },
      {
        id: 'portfolio_reports',
        name: 'Portfolio',
        label: 'Portfolio',
        inline: false,
        type: 'options',
        multiple: true,
        required: ($scope.authDataService.isAdmin() || $scope.authDataService.isWhiteLabelAdmin()),
        placeholder: 'All Portfolios',
        condition: $scope.filterService.portfolios.length > 1 && !$scope.only_account,
        options: $scope.filterService.portfolios,
        conflicts: ['property_reports']
      },
      {
        id: 'property_reports',
        name: 'Property',
        label: 'Property',
        inline: false,
        type: 'property_selector',
        multiple: true,
        required: ($scope.authDataService.isAdmin() || $scope.authDataService.isWhiteLabelAdmin()),
        placeholder: 'All Properties',
        condition: $scope.filterService.properties.length > 1 && !$scope.only_account,
        options: $scope.filterService.properties,
        conflicts: ['portfolio_reports']
      }
    ];
  };

  $scope.initOptions();

  $rootScope.$broadcast('filters-report:initialized');

  $timeout(function() {
    $rootScope.$broadcast('validFilters:updated', $scope.getValidFilters);
    $rootScope.$broadcast('filters-valid:updated', $scope.filters_valid);
    $rootScope.$broadcast('report-type:updated', ReportService.TYPE_CONTACT);
  }, 100);

};

app.controller('ReportsContactListFilters', [
  '$scope',
  '$controller',
  '$timeout',
  '$rootScope',
  'ReportService',
  'ContactTypeRestService',
  'PermissionService',
  ReportsContactListFilters
]);
